/**
 * Returns a promise tha resolves after the given time
 * @param ms - Time to wait in ms
 */
export function delay(ms: number) {
  return new Promise<void>((resolve) => {
    setTimeout(resolve, ms);
  });
}
